<template>
	<v-footer inset app color="primary" height="42">
		<v-col class="text-center lighttext--text" cols="12">
			Versão: 3.2.1
		</v-col>
	</v-footer>
</template>

<script>

	export default{

	}

</script>

<style scoped>
	
</style>